import Cookies from 'js-cookie'
import router from '@/router'
import { dropReportTicket, reportOperation } from '@/api/form.js'
const tagsView = {
  state: {
    visitedViews: [{ path: '/dashboard', routeType: 'home', meta: { name: '首页', title: 'home' } }],
    cachedViews: [],
    needRefresh: true,
    lastTab: localStorage.getItem('lastTab') ? JSON.parse(localStorage.getItem('lastTab')) || [] : [],
    prevTab: undefined
  },
  mutations: {
    ADD_VISITED_VIEW: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) {
        // console.log(view)
        state.needRefresh = false
      } else {
        state.visitedViews.push(view)
        state.needRefresh = true
      }
    },
    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViews.includes(view.name)) return
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },

    DEL_VISITED_VIEW: (state, view) => {
      if (view.routeType === 'create' ||
        view.routeType === 'createWorkFlow' ||
        view.routeType === 'edit') {
        if (view.recordId) { reportOperation(view.templateId, view.recordId, 'close') }
      }
      if (view.ticket) {
        dropReportTicket(view.ticket).then(() => {
          state.needRefresh = false
          state.visitedViews.splice(state.visitedViews.indexOf(view), 1)
        })
      } else {
        state.needRefresh = false
        state.visitedViews.splice(state.visitedViews.indexOf(view), 1)
      }
    },
    DEL_CACHED_VIEW: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },

    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      state.needRefresh = false
      const arr = state.visitedViews.map(v => {
        if (v.ticket) return v.ticket
      })
      arr.map(a => {
        if (a) {
          dropReportTicket(a)
        }
      })
      if (view.path === '/dashboard') {
        state.visitedViews = [{ path: '/dashboard', meta: { name: '首页', routeType: 'home', title: 'home' } }]
      } else {
        state.visitedViews = [...[{ path: '/dashboard', meta: { name: '首页', routeType: 'home', title: 'home' } }], ...state.visitedViews.filter(sv => sv.path === view.path)]
      }
    },
    DEL_OTHERS_CACHED_VIEWS: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, index + 1)
          break
        }
      }
    },

    DEL_ALL_VISITED_VIEWS: state => {
      const arr = state.visitedViews.map(v => {
        if (v.ticket) return v.ticket
      })
      arr.map(a => {
        if (a) {
          dropReportTicket(a)
        }
      })
      state.needRefresh = false
      state.visitedViews = [{ path: '/dashboard', routeType: 'home', meta: { name: '首页', title: 'home' } }]
    },
    DEL_ALL_CACHED_VIEWS: state => {
      state.cachedViews = []
    },

    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViews) {
        if (v.path === view.path) {
          v = Object.assign(v, view)
          break
        }
      }
    },
    // 设置上一次点击
    SET_PRVETAB: (state, prevTab) => {
      state.prevTab = prevTab
    },
    SET_LASTTAB: (state, lastTab) => {
      state.needRefresh = false
      state.lastTab = lastTab
    },
    SET_TICKET: (state, ticket) => {
      state.lastTab.ticket = ticket
    },
    SET_RECORDID: (state, recordId) => {
      state.lastTab.recordId = recordId
      if (state.visitedViews.find(v => v.nodeId === state.lastTab.nodeId)) { state.visitedViews.find(v => v.nodeId === state.lastTab.nodeId).recordId = recordId }
    },
    CHANGE_LASTTAB: (state, data) => {
      const sameTag = state.visitedViews.filter(v => v.nodeId === state.lastTab.nodeId)[0]
      state.lastTab.name = data.name
      state.lastTab.routeType = data.routeType
      sameTag.name = data.name
      sameTag.routeType = data.routeType
    }

  },
  actions: {
    ChangeLastTab({ commit, state }, data) {
      commit('CHANGE_LASTTAB', data)
      localStorage.setItem('lastTab', JSON.stringify(state.lastTab))
    },
    setRecordId({ commit }, recordId) {
      commit('SET_RECORDID', recordId)
    },
    setTicket({ commit }, ticket) {
      commit('SET_TICKET', ticket)
    },
    SetPrevTab({ commit, state }, prevTab) {
      // 设置上一次点击
      commit('SET_PRVETAB', prevTab)
    },
    SetLastTab({ commit, state }, lastTab) {
      commit('SET_LASTTAB', lastTab)
      localStorage.setItem('lastTab', JSON.stringify(lastTab))
    },
    addView({ dispatch }, view) {
      dispatch('addVisitedView', view)
      // dispatch('addCachedView', view)
    },
    addVisitedView({ commit, dispatch, state }, view) {
      // 1、历史记录页面下，点击查看，打开查看tab，然后返回历史记录页面，点击修改，则返回同一tab并且将状态【切换为修改】
      // 2、历史记录页面下，点击修改，打开修改tab，然后返回历史记录页面，点击查看，则返回同一tab并且将状态【不变】
      // 3、历史记录页面下，点击修改，打开修改tab，用户修改完内容保存并不关闭tab，然后返回历史记录页面，点击查看，则返回同一tab并且将状态【切换为查看】
      // 4、历史记录页面下，点击修改，打开修改tab，用户修改完内容保存并不关闭tab，然后返回历史记录页面，点击修改，则返回同一tab并且将状态【切换为修改】
      if (view.routeType === 'edit' || view.routeType === 'check') {
        const samePath = state.visitedViews.filter(v => (+v.recordId === +state.lastTab.recordId) && (+v.templateId === +state.lastTab.templateId) && (v.routeType === 'edit' || v.routeType === 'check'))[0]
        if (samePath) {
          if (samePath.routeType === 'check') {
            dispatch('delView', samePath).then(() => {
              router.push(view.path)
              commit('ADD_VISITED_VIEW', view)
            })
          } else {
            router.push(samePath.path)
            commit('ADD_VISITED_VIEW', samePath)
          }
        } else {
          router.push(view.path)
          commit('ADD_VISITED_VIEW', view)
        }
      } else if (view.routeType === 'create') {
        const create = state.visitedViews.find(sv => sv.path === view.path && sv.recordId > 0)
        if (create) {
          if (state.lastTab.path !== view.path) {
            dispatch('delView', create).then(() => {
              router.push(view.path)
              state.needRefresh = true
              dispatch('SetLastTab', view)
              commit('ADD_VISITED_VIEW', view)
            })
          }
        } else {
          if (view.temporaryId) {
            router.push({
              path: view.path,
              query: {
                temporaryId: view.temporaryId
              }
            })
          } else {
            router.push(view.path)
          }
          dispatch('SetLastTab', view)
          commit('ADD_VISITED_VIEW', view)
        }
      } else {
        commit('ADD_VISITED_VIEW', view)
      }
    },
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },

    delView({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delVisitedView', view)
        dispatch('delCachedView', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delVisitedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
    delCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },

    delOthersViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delOthersVisitedViews', view)
        dispatch('delOthersCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delOthersVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersCachedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_CACHED_VIEWS', view)
        resolve([...state.cachedViews])
      })
    },

    delAllViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delAllVisitedViews', view)
        dispatch('delAllCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delAllVisitedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_VISITED_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    delAllCachedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_CACHED_VIEWS')
        resolve([...state.cachedViews])
      })
    },

    updateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    }
  }
}

export default tagsView
